import cloneDeep from 'lodash/cloneDeep';
import { defaultProps, setUserId } from './defaultEventProps';

export const loginSuccess = ({ userId }) => {
    const eventProps = cloneDeep(defaultProps);
    setUserId(userId, eventProps);

    return {
        name: 'Login',
        details: eventProps,
    };
};

// Login started and failed events removed due to issues with `mixpanel.alias`:
// - unable to determine if alias already called with frontend sdk only
// - always calling alias always creates a separate user profile but does associate anonymous events to logged in user
// - manually calling alias once does not track subsequent anonymous events, essentially the same as not calling alias
// - distinct_id is no longer the specified user id in `mixpanel.identitfy` but appears to be expected behaviour,
// see https://community.mixpanel.com/sending-data-to-mixpanel-11/what-am-i-doing-wrong-with-identify-2239

// TODO: reconsider associating anonymous events after user logs in if id merge is enabled
// or the mixpanel api is used directly with just the project token
// see https://developer.mixpanel.com/reference/identities#identity-create-alias